export default "__VITE_ASSET__CWlEfRgu__"